__turbopack_context__.v({
  "className": "jetbrains_mono_aea462-module__BKGX-W__className",
  "variable": "jetbrains_mono_aea462-module__BKGX-W__variable",
});
